import { useState, useEffect, useContext } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { Typography, Alert, Box, Link } from "@mui/material";

import Form from "../../components/Form/Form";
import Input from "../../components/Form/Input/Input";

import { BrandContext } from "../../App";
import { useTheme } from "@mui/material/styles";

import Logo from "../../assets/logos/2x-logo.png";
import LoginBG from "../../assets/laptop-mockup.jpg";

import { LoginContainer } from "./styles";

import LinearProgress from "@mui/material/LinearProgress";

import DefaultButton from "../../components/simple/DefaultButton";

const LoginPage = () => {
  const theme = useTheme();
  // const [showPassword, setShowPassword] = useState(false);
  // const [showPasswordResetLink, setShowPasswordResetLink] = useState(false);
  // const [loginCredentials, setLoginCredentials] = useState({});
  const [loginErrorMessage, setLoginErrorMessage] = useState(false);
  const [loading, setLoading] = useState(false);
  const { brand, authToken, saveAuthToken } = useContext(BrandContext);

  const navigate = useNavigate();
  const [qParams] = useSearchParams();
  
  useEffect(() => {
    redirect();
  }, [authToken]);

  const redirect = () => {
    if (authToken.length > 0) {
      if (qParams.has("next") && qParams.get("next") !== "/login") {
        navigate(qParams.get("next"), { replace: true });
      } else {
        navigate("/dashboard/home", { replace: true });
      }
    }
  };

  const handleLogin = (data) => {
    setLoading(false);
    saveAuthToken(data["token"]);
    redirect();
  };

  const handleError = () => {
    setLoginErrorMessage(true)
    setLoading(false)
  }

  // Will need reworking later into the new <Form> component
  // Not sure if this is actually needed here anymore as there is a page for reset_password
  // ----------
  // const requestPasswordReset = () => {
  //   fetch(`${brand.api_base_url}/request_password_reset`, {
  //     method: "POST",
  //     headers: { "Content-Type": "application/json" },
  //     body: JSON.stringify({ username: loginCredentials["username"] }),
  //   });

  //   setShowPasswordResetLink(false);
  //   setLoginErrorMessage(
  //     "We have sent a password reset link to this e-mail address."
  //   );
  // };

  return (
    <Box
      sx={{
        backgroundColor: theme.palette.background.primary,
        height: "100vh",
        paddingTop: "20px",
        paddingBottom: "20px",
        display: "flex",
        alignItems: "center",
        alignSelf: "stretch",
      }}
    >
      <LoginContainer>
        <div className="form-container">
          <div className="login-form">
            <img src={Logo} alt="Guru Now" />
            <Typography variant="h1">Welcome back</Typography>
            {qParams.has("after") ? (
              <Alert severity="success" sx={{ mt: 2, mb: 2 }}>
                Your password was changed successfully. Please log in with your
                new password.
              </Alert>
            ) : (
              <p>Please enter your login details</p>
            )}
            <Form
              action={`${brand.api_base_url}/api-token-auth/`}
              onBefore={() => setLoading(true)}
              onSuccess={handleLogin}
              onError={handleError}
            >
              {({ register, formState: { errors } }) => (
                <>
                  <Input
                    id="login-email"
                    showLabel
                    label="Email"
                    type="email"
                    register={register("username", {
                      required: "Email address is required",
                    })}
                    error={errors.username?.message}
                  />
                  <Input
                    id="login-password"
                    showLabel
                    label="Password"
                    type="password"
                    register={register("password", {
                      required: "Password is required",
                    })}
                    error={errors.password?.message}
                  />
                  <div className="login-utils">
                    <div className="remember-me">
                      <Input
                        id="login-remember"
                        showLabel
                        label="Remember for 30 days"
                        type="checkbox"
                        register={register("remember")}
                      />
                    </div>
                    <Link className="forgot-link" href="/reset_password">
                      Forgot password?
                    </Link>
                  </div>
                  {loginErrorMessage && (
                    <>
                      <Alert severity="error" sx={{ mb: 4 }}>
                        There was a problem logging you in - please try again.
                      </Alert>
                    </>
                  )}
                  <DefaultButton type="submit">
                    Login
                  </DefaultButton>
                  {loading && (
                    <LinearProgress
                      id="login-loading"
                      color="secondary"
                      sx={{ mt: 5, height: "8px", borderRadius: "6px" }}
                    />
                  )}
                </>
              )}
            </Form>
            <div className="register-helper">
              Don't have an account?{" "}
              <Link className="sign-up-link" href="">
                Sign up
              </Link>
            </div>
          </div>
        </div>
        <div className="full-background">
          <img src={LoginBG} alt="" />
        </div>
      </LoginContainer>
    </Box>
  );
};

export default LoginPage;
